<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>

<template>
  <div class="bg-primary py-16">
    <div class="section-container">
      <div class="bg-white p-6 md:p-12 rounded-lg shadow-lg">
        <h2 class="text-4xl md:text-5xl">{{ $t('Doelgerichte inzet en ondersteuning') }}</h2>
        <p
          class="mt-4 text-lg leading-relaxed"
        >Het inzetten van medewerkers met specifieke expertise die passen bij uw organisatie of situatie.</p>
        <p
          class="mt-4 text-lg leading-relaxed"
        >Het opzetten van verbetertrajecten om processen te optimaliseren en duurzame veranderingen door te voeren.</p>
        <p
          class="mt-2 text-lg leading-relaxed"
        >Wij geloven dat zorg verder gaat dan alleen het oplossen van acute problemen. Onze aanpak is gericht op het optimaliseren van de kwaliteit en continuïteit, zodat u niet alleen vandaag, maar ook in de toekomst goed ondersteund wordt.</p>

        <!-- Steps Section -->
        <div class="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
          <!-- Step 1 -->
          <div>
            <p class="bg-[#A5C9B1] text-white text-2xl font-bold rounded-md z-10 p-5 m-2">1</p>
            <h3 class="text-xl font-bold mt-4">Intakegesprek</h3>
            <p class="mt-2 text-lg">Tijdens een intakegesprek bespreken wij uw wensen en doelen.</p>
          </div>

          <!-- Step 2 -->
          <div>
            <p class="bg-[#A5C9B1] text-white text-2xl font-bold rounded-md z-10 p-5 m-2">2</p>
            <h3 class="text-xl font-bold mt-4">Werving</h3>
            <p class="mt-2 text-lg">Zorgblik werft geschikte kandidaten voor u.</p>
          </div>

          <!-- Step 3 -->
          <div>
            <p class="bg-[#A5C9B1] text-white text-2xl font-bold rounded-md z-10 p-5 m-2">3</p>
            <h3 class="text-xl font-bold mt-4">Begeleiding</h3>
            <p class="mt-2 text-lg">Wij begeleiden u tijdens het sollicitatieproces.</p>
          </div>

          <!-- Step 4 -->
          <div>
            <p class="bg-[#A5C9B1] text-white text-2xl font-bold rounded-md z-10 p-5 m-2">4</p>
            <h3 class="text-xl font-bold mt-4">Evaluatie</h3>
            <p class="mt-2 text-lg">Na plaatsing evalueren wij de samenwerking.</p>
          </div>
        </div>

        <p class="mt-8 text-lg leading-relaxed">
          <b>Met ZorgBlik kiest u voor een partner die begrijpt dat goede zorg ontstaat vanuit een samenwerking waarin verbindend organiseren centraal staat. We bouwen niet alleen aan oplossingen maar ook aan een constructieve samenwerking met een blik op de toekomst.</b>
        </p>
        <p class="mt-2 text-lg leading-relaxed">
          <b>Zorgblik Uitzendbureau: samen bouwen aan duurzame zorg die werkt.</b>
        </p>
      </div>
    </div>
  </div>
</template>
